<span *ngIf='show && !disable'> 
	<span class='glyphicon glyphicon-refresh glyphicon-refresh-animate gly-spin'></span>
</span>